import { DiscoveryCardType } from '@ninjacart/nc-nk-store';
import { Paragraph, XStack, Text } from '@ninjacart/nc-nk-ui';
import { Link } from 'solito/link';

const ViewAll = ({ item, handleNavigation, t }) => {
  return (
    <XStack display="flex" justifyContent="space-between" marginBottom={10}>
      <Text fontSize={18} fontWeight={'600'} color={'$usertextColor'}>
        {t(`${item?.cardDetails?.name}`)}
      </Text>
      <Text
        fontSize={14}
        fontWeight={'400'}
        color={'$color'}
        textDecorationLine="underline"
        onPress={() => handleNavigation(item)}
        testID="kisan_tId_viewAll"
      >
        {/* <Link href={item.type === DiscoveryCardType.CONTINUE_WATCHING ? '/continueWatchViewAll' : item.type.includes('playlists') ? '/playList' : '/trendingViewAllList'} shallow> */}
        <Text>{t(`page.viewAll`)}</Text>
        {/* </Link> */}
      </Text>
    </XStack>
  );
};

export default ViewAll;
